package org.hs_soft.runmynesto.domain.usecase.login

import org.hs_soft.runmynesto.domain.repository.network_datasource.login.SignInRepository


class SignInUseCase(
    private val repository: SignInRepository
) {
    operator fun invoke(
        userName:String,
        password:String,
        mfaCode:String,
        isSecondStep:Boolean,
        goToSecondStep:()->Unit,
        onSuccess:()->Unit,
        onError:(String)->Unit,
    ) {
        repository.signIn(
            userName = userName,
            password=password,
            mfaCode=mfaCode,
            isSecondStep = isSecondStep,
            goToSecondStep={
                goToSecondStep()
            },
            onSuccess = {
                onSuccess()
            },
            onError={
                onError(it)
            }

        )
    }
}